'use client';

import { useEffect, useState } from 'react';

import type { InputRequiredProfileRedirectStatus } from '../models';
import { useFetchCurrentUserCheckInputRequiredProfileQuery } from './graphql';

type Props = {
  redirectParamsPath?: string;
  isSkippedRedirect?: boolean;
};

// プロフィール未突破ユーザーの初回プロフィール画面へのリダイレクト
export function useCurrentUserCheckInputRequiredProfileRedirect({
  redirectParamsPath,
  isSkippedRedirect,
}: Props) {
  const [
    inputRequiredProfileRedirectStatus,
    setInputRequiredProfileRedirectStatus,
  ] = useState<InputRequiredProfileRedirectStatus>('loading');

  const { data: currentUserData, loading: isCurrentUserLoading } =
    useFetchCurrentUserCheckInputRequiredProfileQuery({
      skip: isSkippedRedirect,
    });

  useEffect(() => {
    if (isCurrentUserLoading) {
      // ローディング中は何もしない
      return;
    }

    if (
      !currentUserData?.currentUser ||
      currentUserData.currentUser.setting?.hasInputRequiredProfile
    ) {
      setInputRequiredProfileRedirectStatus('notRedirected');
      return;
    }

    const redirectPath = redirectParamsPath
      ? `/steps/profile?r=${encodeURIComponent(redirectParamsPath)}`
      : '/steps/profile';

    window.location.href = redirectPath;

    setInputRequiredProfileRedirectStatus('redirected');
  }, [isCurrentUserLoading, currentUserData]);

  return { inputRequiredProfileRedirectStatus };
}
